<template>
  <div>
    <my-asidebar v-bind:active-tab="'agency-outline'"> </my-asidebar>


    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">Acente Muhasebe</h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li>Acente Muhasebe</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <agency-outline-list/>
        <create-agency-payment-popup/>
        <agency-payment-list-modal/>
      </div>
    </section>

  </div>
</template>

<script>
import TopBar from "../component/common/TopBar";
import MyAsidebar from "../component/common/MyAsidebar";
import AgencyOutlineList from "../component/agency/AgencyOutlineList";
import CreateAgencyPaymentPopup from "../component/agency/CreateAgencyPaymentPopup";
import AgencyPaymentListModal from "../component/agency/AgencyPaymentsListModal";

export default {
  name: "AgencyPaymentsOutlinePage",
  components: {AgencyPaymentListModal, CreateAgencyPaymentPopup, AgencyOutlineList, MyAsidebar, TopBar},
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_AGENCY_PAYMENTS_OUTLINE"]) this.$router.push("/");

    this.$store.dispatch("loadAgencyPaymentOutlines");
  }
}
</script>

<style scoped>

</style>